// Mock data for the Growth Hacking portfolio site

export const stats = [
  { value: '200%', label: 'Open Rate Boost' },
  { value: '10-100x', label: 'Revenue Growth' },
  { value: '2,000+', label: 'Downloads' }
];

export const services = [
  {
    id: 1,
    icon: 'zap',
    title: 'Full Email System Build',
    description: 'Lead magnet + delivery, welcome flow, 2–3 month nurture map, and weekly broadcast template.',
    benefit: 'Predictable lead-to-client journeys and higher LTV.'
  },
  {
    id: 2,
    icon: 'mail-check',
    title: 'Deliverability & Inbox Placement Fix',
    description: 'SPF/DKIM/DMARC setup, warm-up plan, inbox placement testing.',
    benefit: 'Higher inboxing, fewer bounces, reliable campaign performance.'
  },
  {
    id: 3,
    icon: 'refresh-cw',
    title: 'Migration & Cleanup',
    description: 'Migration & tag mapping (ActiveCampaign / Mailchimp → Kit.com), dedupe, and automation rebuild.',
    benefit: 'Minimal subscriber churn, no accidental re-enrolments, stable automations.'
  },
  {
    id: 4,
    icon: 'trending-up',
    title: 'Newsletter Monetization',
    description: 'Monetization blueprint, sales funnel from newsletter → checkout, UTM tracking.',
    benefit: 'Newsletter becomes a revenue engine, not just a channel.'
  },
  {
    id: 5,
    icon: 'message-circle',
    title: 'ManyChat Funnels',
    description: 'Chat-based lead capture + email sync for multi-channel remarketing.',
    benefit: 'Faster pre-qualification and higher conversion.'
  },
  {
    id: 6,
    icon: 'repeat',
    title: 'Retainer: Strategy + Execution',
    description: 'Weekly support — campaign builds, subject testing, reporting and optimizations.',
    benefit: 'Continuous improvement and less client admin.'
  }
];

export const caseStudies = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&h=400&fit=crop',
    badge: 'Reduced operational overhead',
    clientName: 'Francisco Torres',
    tagline: 'Systems that make his content sell',
    description: 'Built systems & migration from ActiveCampaign → Kit.com that scaled his funnels and reduced manual work.',
    fullDescription: 'Francisco Torres came to us with a complex ActiveCampaign setup that was becoming unmanageable. We migrated his entire system to Kit.com, rebuilt his automations with better segmentation, and created a scalable infrastructure that reduced his operational overhead by 60% while improving conversion rates by 35%.'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=600&h=400&fit=crop',
    badge: '17% → 87% open rate',
    clientName: 'Amber — The Well Drop',
    tagline: 'Podcast → Newsletter conversion',
    description: 'Newsletter managed to lift open rates from 17% → 87% in 5 months.',
    fullDescription: 'Amber was struggling with low engagement on her wellness podcast newsletter. Through strategic content restructuring, subject line optimization, and audience segmentation, we transformed her newsletter into a highly engaged community with open rates jumping from 17% to 87% over 5 months.'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop',
    badge: 'Improved inbox performance',
    clientName: 'Chozan / Ashley Dudarenok',
    tagline: 'Streamlining B2B newsletters',
    description: 'Streamlined B2B newsletter operations, segmentation and site support (MailerLite).',
    fullDescription: 'Working with Ashley Dudarenok at Chozan, we optimized their B2B newsletter operations on MailerLite. By implementing proper segmentation, improving deliverability setup, and creating targeted content workflows, we increased inbox placement rates and reduced unsubscribe rates significantly.'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
    badge: '4× uplift in conversions',
    clientName: 'Vishakha',
    tagline: 'Retainer support that scaled revenue',
    description: 'Supported >1 year; 4× sales on birthday promotion + consistent, segmented email programs.',
    fullDescription: 'Through ongoing retainer support spanning over a year, we helped Vishakha scale her email revenue dramatically. Our strategic campaign planning, including a highly successful birthday promotion that generated 4× the usual sales, combined with consistent segmented email programs, created a predictable revenue stream from her email list.'
  }
];

export const profileData = {
  name: 'Akash Tiwari',
  title: 'Growth Hacking Expert',
  status: 'Available for consultation',
  image: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/render/image/public/document-uploads/IMG_4316-1764330288919.jpg?width=800&height=800&resize=contain'
};
